<!--
 * @Author: filename
 * @Description: 个人信息表 - 工作经验
-->
<template>
    <!-- 回显信息 -->
    <div ref="userDetail" class="details-module common-part">
        <!-- 主申请人信息 -->
        <el-row :gutter="15">
            <!-- 高才A类 - 收入种类 -->
            <el-col :span="24" v-if="Number(applicationType) === 1">
                <span>收入种类：</span>
                <span>{{ incomeTypeFilter(currentItem.type_of_income) }}</span>
            </el-col>
            <el-col :span="12" id="company_name">
                <span>用人单位：</span>
                <span>{{ currentItem.company_name || "-" }}</span>
            </el-col>
            <el-col :span="12" id="career">
                <span>职业：</span>
                <span>{{ currentItem.career || "-" }}</span>
            </el-col>
            <el-col :span="12" id="company_type">
                <span>界别：</span>
                <span>{{ currentItem.company_type || "-" }}</span>
            </el-col>
            <el-col :span="12" id="company_type_other">
                <template v-if="currentItem.company_type === '其它 （请注明）'">
                    <span>其它 （请注明）：</span>
                    <span>{{ currentItem.company_type_other || "-" }}</span>
                </template>
            </el-col>
            <el-col :span="12" id="entry_time">
                <span>入职年月：</span>
                <span>{{ currentItem.entry_time || "-" }}</span>
            </el-col>
            <el-col :span="12" id="departure_time">
                <span>离职年月：</span>
                <span>{{ currentItem.work_to_now != 1 ? (currentItem.departure_time || '-') : '至今' }}</span>
            </el-col>
            <!-- <el-col :span="12" id="payroll_unit_location">
                <span>发薪单位地点：</span>
                <span>{{ payrollUnitLocation(currentItem.payroll_unit_location) }}</span>
            </el-col> -->
            <!-- 来源公司类型 -->
            <el-col :span="12" id="company_source">
                <span>来源公司类型：</span>
                <span>{{ companySourceFilter(currentItem.company_source) }}</span>
            </el-col>
            <!-- 评税文件所属国家/地区 -->
            <el-col :span="12" id="tax_assessment_address">
                <span>评税文件所属国家/地区：</span>
                <span>{{ taxAssessmentAddressFilter(currentItem.tax_assessment_address) }}</span>
            </el-col>
            <!-- 收入来源 - 仅在来源公司类型=1时显示 -->
            <el-col :span="24" id="income_source" v-if="currentItem.company_source === 1">
                <span>收入来源：</span>
                <span>{{ incomeSourceFilter(currentItem.income_source) }}</span>
            </el-col>
            <!-- 业务收入相关字段 - 仅在收入来源包含'业务收入'时显示 -->
            <template v-if="currentItem.company_source === 1 && hasBusinessIncome(currentItem.income_source)">
                <el-col :span="12" id="shareholding_start_time">
                    <span>持股开始时间：</span>
                    <span>{{ currentItem.shareholding_start_time || '-' }}</span>
                </el-col>
                <el-col :span="12" id="shareholding_end_time">
                    <span>持股结束时间：</span>
                    <span>{{ currentItem.shareholding_end_time || '-' }}</span>
                </el-col>
                <!-- 评税周期 - 仅在评税地区为2或3时显示 -->
                <template v-if="currentItem.tax_assessment_address === 2 || currentItem.tax_assessment_address === 3">
                    <el-col :span="12" id="tax_assessment_start_time">
                        <span>评税周期开始时间：</span>
                        <span>{{ currentItem.tax_assessment_start_time || '-' }}</span>
                    </el-col>
                    <el-col :span="12" id="tax_assessment_end_time">
                        <span>评税周期结束时间：</span>
                        <span>{{ currentItem.tax_assessment_end_time || '-' }}</span>
                    </el-col>
                </template>
                <el-col :span="12" id="shareholding_percentage">
                    <span>持股比例：</span>
                    <span>{{ currentItem.shareholding_percentage ? currentItem.shareholding_percentage + '%' : '-' }}</span>
                </el-col>
            </template>
            <el-col :span="24">
                <span>工作证明是否可以提供?</span>
                <span>{{ currentItem.has_work_certificate === 1 ? '是' : currentItem.has_work_certificate === 2 ? '否' : '-' }}</span>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import CONFIG from "../../config"

export default {
    props: {
        currentItem: {
            type: Object,
            default() {
                return {}
            },
        },
        applicationType: {
            type: Number | String,
            default:() => ''
        },
    },
    data() {
        return {
            CONFIG,
        }
    },
    methods: {
        payrollUnitLocation(location) {
            let _location = location
            if (_location && _location.country) {
                if (_location.country.includes('中国')) {
                    return `${_location.country}${_location.area.join('')}`
                } else {
                    return `${_location.country}${_location.foreign}`
                }
            }
            return '-'
        },
        incomeTypeFilter(val) {
            return this.CONFIG.INCOMING_TYPE
                .filter(item1 => val.some(item2 => item1.value === item2))
                .map(item => item.name)
                .join(', ') || '-'
        },
        /**
         * @description 来源公司类型过滤
         */
        companySourceFilter(val) {
            const map = {
                1: '来自于你所拥有的公司（包括业务收入及就业薪酬）',
                2: '来自于其他公司的就业收入'
            }
            return map[val] || '-'
        },
        /**
         * @description 评税文件所属国家/地区过滤
         */
        taxAssessmentAddressFilter(val) {
            const map = {
                1: '中国内地',
                2: '中国港澳台',
                3: '海外'
            }
            return map[val] || '-'
        },
        /**
         * @description 收入来源过滤
         */
        incomeSourceFilter(val) {
            if (!val) return '-'

            const map = {
                1: '业务收入',
                2: '就业收入'
            }

            // 处理数组格式
            let sources = []
            if (Array.isArray(val)) {
                sources = val
            } else if (typeof val === 'string') {
                sources = val.split(',').map(item => Number(item.trim()))
            }

            return sources.map(item => map[item]).filter(Boolean).join(', ') || '-'
        },
        /**
         * @description 判断是否包含业务收入
         */
        hasBusinessIncome(val) {
            if (!val) return false

            if (Array.isArray(val)) {
                return val.includes(1)
            } else if (typeof val === 'string') {
                return val.split(',').map(item => Number(item.trim())).includes(1)
            }

            return false
        }
    }
};
</script>

<style lang="less" scoped>
.declaration {
    align-items: flex-start !important;
}
</style>
